export enum ClientEntity {
    EMAILS = 'emails',
    PHONES = 'phones',
    ADDRESSES = 'addresses',
    SIGNATORIES = 'signatories',
    INVOICERIES = 'invoiceries',
    REMINDERS = 'reminders',
}
